<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button class="mr15" type="primary" v-if="getPermission('ymsWarehousePriceModel_inset')"
        @click="$refs['costAllocation'].initCostAllocationData('add')">
        {{ $t('key1005135') }}
      </Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--费用配置弹窗-->
    <costAllocationModal
      systemType="yms"
      ref="costAllocation"
      :warehouseList="warehouseList"
      @updateData="getList()">
    </costAllocationModal>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG']"></commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import costAllocationModal from "@/components/common/costAllocationModal.vue";
import commonLogModal from "@/components/common/commonLogModal";
import {getAllUsersInfo, getAllYmsWarehouseData, getUserNameByUserId} from "@/utils/common";

export default {
  name: "distributorFeeAllocation",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003655'),
          key: 'type',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let type = params.row.type;
            let text = type === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213') : type === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002445') : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'),
          key: 'ymsWarehouseId',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let text = '-';
            let ymsWarehouseId = params.row.ymsWarehouseId;
            if (v.warehouseList.length > 0) {
              v.warehouseList.map((item) => {
                if (item.ymsWarehouseId === ymsWarehouseId) {
                  text = item.name;
                }
              });
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005127'),
          key: 'feeRules',
          minWidth: 520,
          align: 'left',
          render(h, params) {
            let billingType = params.row.billingType;
            let ymsWarehousePriceModelDetails = params.row.ymsWarehousePriceModelDetails || [];
            if (ymsWarehousePriceModelDetails.length > 0) {
              let obj = ymsWarehousePriceModelDetails[0];
              let list = [];
              if (billingType === 1) {
                list = [
                  h('p', {class: 'mt4 mb2'}, `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')} ${obj.packageHandlerCost} ${obj.currency} / ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002123')}`),
                  h('p', {class: 'mt2 mb4'}, `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005125')} ${obj.addPackageHandlerCost} ${obj.currency} / ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005126')}`),
                ];
              } else {
                switch (obj.billingType) {
                  case 1:
                    list = [
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005128')),
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005129')),
                    ];
                    break;
                  case 2:
                    list = [
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005130')),
                      h('p', {class: 'mt4 mb2'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005131')),
                      h('p', {class: 'mt2 mb4'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005132')),
                    ];
                    break;
                  case 3:
                    list = [
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005133')),
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005134')),
                    ];
                    break;
                }
              }
              return h('div', list);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002476'),
          key: 'updatedBy',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            return h('span', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477'),
          key: 'updatedTime',
          minWidth: 170,
          align: 'left',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 160,
          align: 'left',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsWarehousePriceModel_update'),
                    clickFn: () => {
                      v.$refs['costAllocation'].initCostAllocationData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(params.row.ymsWarehousePriceModelId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      warehouseList: [],
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化数据
    initFun() {
      let v = this;
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await getAllYmsWarehouseData().then((data) => {
          v.warehouseList = data;
        });
        await v.getList();
      })();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsWarehousePriceModel_query')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsWarehousePriceModel_query).then(response => {
          if (response.data.code === 0) {
            v.tableData = response.data.datas || [];
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
  },
  components: {
    costAllocationModal,
    commonLogModal
  }
};
</script>

<style lang="less" scoped>

</style>